import React from "react";

import { SvgWrapper } from "../styles";

interface SvgComponentProps {
  height: number;
  width: number;
  color: string;
}

const IconCloseCircle = (props: SvgComponentProps) => {
  const { width, height, color } = props;

  return (
    <SvgWrapper>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        fill="none"
        viewBox="0 0 20 20"
      >
        <path
          fill={color}
          d="M10 18.959c-4.942 0-8.958-4.017-8.958-8.959 0-4.941 4.016-8.958 8.958-8.958S18.958 5.059 18.958 10c0 4.942-4.016 8.959-8.958 8.959zm0-16.667C5.75 2.292 2.292 5.75 2.292 10S5.75 17.71 10 17.71 17.708 14.25 17.708 10 14.25 2.292 10 2.292z"
        ></path>
        <path
          fill={color}
          d="M7.642 12.984A.618.618 0 017.2 12.8a.629.629 0 010-.883L11.917 7.2a.629.629 0 01.883 0 .629.629 0 010 .884L8.083 12.8a.605.605 0 01-.441.184z"
        ></path>
        <path
          fill={color}
          d="M12.358 12.984a.618.618 0 01-.441-.184L7.2 8.084a.629.629 0 010-.884.629.629 0 01.883 0l4.717 4.717a.629.629 0 010 .883.618.618 0 01-.442.184z"
        ></path>
      </svg>
    </SvgWrapper>
  );
};

export default IconCloseCircle;
